<template>
    <div class="mask">
        <div class="con" :style="{ width: `${width / 19.20}vw`, height: `${height / 19.20}vw` }">
            <div v-if="showClose" class="close-confirm" @click="closeDialog"></div>
            <div class="recharge-box">
                <div class="recharge-title-div">{{ title }}</div>
                <div class="recharge-main">
                    <slot></slot>
                </div>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        showClose: {
            type: Boolean,
            default: true
        },
        height: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: ''
        },
    },
    data () {
        return {}
    },
    mounted () {
    },
    methods: {
        closeDialog () {
        },
    },
}
</script>
<style lang="less" scoped>
.mask {
    position: fixed;
    z-index: 200;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .recharge-box {
        width: 100%;
        height: 100%;
        padding: 0 15px 15px 15px;
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .recharge-title-div {
        width: 100%;
        height: 47px;
        //padding-top: 30px;
        margin: 15px auto;
        //margin-top: 20px;
        color: #B0CAEB;
        font-size: 30px;
        font-weight: 800;
    }
    .recharge-main {
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        flex: 1;
    }

    .recharge-title {
        //margin-bottom: 45px;
    }

    .con {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        color: #808080;
        box-sizing: border-box;
        padding: 10px;
        background-image: url('@/assets/images/recharge/dialog-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        font-family: "微软雅黑";

        .close-confirm {
            position: absolute;
            right: -60px;
            top: 0;
            cursor: pointer;
            width: 40px;
            height: 40px;
            background-image: url("@/assets/images/close-confirm.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>
